import { loadGSAP } from '../../externals/gsap.js';
import { loadScrollTrigger } from '../../externals/scroll-trigger.js';

export const defaults = {
  speed: 0.5,             // 0 = static, 1 = scrolls with page, 0.5 = half speed
  direction: 'vertical',  // vertical | horizontal
};

export default async function parallax(el, options) {
  await loadGSAP();
  await loadScrollTrigger();
  const { gsap } = window;

  const speed    = parseFloat(options.speed);
  const vertical = options.direction !== 'horizontal';
  const prop     = vertical ? 'yPercent' : 'xPercent';

  // Movement range as a percentage: slower speed → more parallax travel
  const movement = (1 - speed) * 60;

  gsap.fromTo(el,
    { [prop]: -movement / 2 },
    {
      [prop]: movement / 2,
      ease: 'none',
      scrollTrigger: {
        trigger: el,
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
      },
    },
  );
}
